import { render, staticRenderFns } from "./numberChoiceType.vue?vue&type=template&id=6f192b59"
import script from "./numberChoiceType.vue?vue&type=script&lang=js"
export * from "./numberChoiceType.vue?vue&type=script&lang=js"
import style0 from "./numberChoiceType.vue?vue&type=style&index=0&id=6f192b59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports